export default function numberRangeFormatter() {
  return (input:any[], start: number, end: number) => {

    for (var i=start; i<=end; i++) {
      input.push(i);
    }

    return input;
  }
}


/** WEBPACK FOOTER **
 ** ./app/utils/number-range.formatter.ts
 **/